// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_1EorIlHK8FT6eFVN01fFyG"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ArrowIcon/styles.css
// module id = 1053
// module chunks = 0